var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTariaBronze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsv: "https://svgstorm.com",
    viewBox: "0 0 160 160",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 0.00 160.00  L 160.00 160.00 L 160.00 0.00 L 0.00 0.00 L 0.00 160.00 M 90.00 8.00  C 142.76 14.38 168.26 81.61 136.25 122.25 C 104.23 162.89 38.12 160.54 14.69 110.31 C -8.73 60.07 32.38 1.04 90.00 8.00 Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#31100B",
    strokeOpacity: 0.95,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 90.00 8.00  C 32.38 1.04 -8.73 60.07 14.69 110.31 C 38.12 160.54 104.23 162.89 136.25 122.25 C 168.26 81.61 142.76 14.38 90.00 8.00 M 116.00 29.00  C 125.93 36.10 134.10 46.60 138.00 58.00 C 148.64 89.10 132.99 124.29 101.98 135.98 C 70.96 147.66 35.61 133.81 22.00 103.00 C 10.86 77.79 18.89 47.85 40.25 30.25 C 61.61 12.64 93.94 13.24 116.00 29.00 Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#985239",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 22.00 103.00  C 24.98 105.37 32.56 101.46 33.00 98.00 C 11.66 54.85 67.98 13.84 105.00 37.00 C 110.24 38.33 113.07 34.51 118.00 33.00 C 118.55 31.18 116.25 30.53 116.00 29.00 C 93.94 13.24 61.61 12.64 40.25 30.25 C 18.89 47.85 10.86 77.79 22.00 103.00 Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#8B4732",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 105.00 37.00  C 115.33 43.46 123.03 54.39 126.00 66.00 C 129.11 68.64 137.84 60.76 138.00 58.00 C 134.10 46.60 125.93 36.10 116.00 29.00 C 116.25 30.53 118.55 31.18 118.00 33.00 C 113.07 34.51 110.24 38.33 105.00 37.00 Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#4F140A",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 33.00 98.00  C 44.30 120.86 68.57 133.50 93.22 125.22 C 117.88 116.94 132.67 92.13 126.00 66.00 C 123.03 54.39 115.33 43.46 105.00 37.00 C 67.98 13.84 11.66 54.85 33.00 98.00 M 116.00 59.00  C 127.29 75.79 121.39 101.06 104.75 113.75 C 88.12 126.45 61.83 124.12 47.00 109.00 C 51.37 104.30 53.35 98.24 59.25 94.25 C 65.15 90.26 78.84 94.64 86.00 93.00 C 88.30 97.96 82.65 104.87 87.93 109.07 C 93.20 113.27 93.13 101.96 93.00 98.00 C 92.87 94.04 91.60 84.13 93.78 80.78 C 95.96 77.43 108.71 83.39 105.00 74.00 C 87.29 76.70 96.06 58.39 94.00 47.00 C 75.15 61.51 61.21 87.37 41.00 101.00 C 30.08 80.84 36.53 52.42 57.23 41.23 C 77.93 30.04 105.28 37.89 116.00 59.00 M 86.00 65.00  C 87.51 71.06 84.77 76.02 78.00 74.00 C 78.97 70.23 83.14 67.45 86.00 65.00 M 86.00 80.00  C 88.06 90.68 73.26 84.27 67.00 86.00 C 69.32 77.32 79.28 80.54 86.00 80.00 Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#914B35",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 105.00 74.00  C 110.03 73.23 113.97 68.84 119.00 68.00 C 118.95 64.74 117.41 61.87 116.00 59.00 C 105.28 37.89 77.93 30.04 57.23 41.23 C 36.53 52.42 30.08 80.84 41.00 101.00 C 61.21 87.37 75.15 61.51 94.00 47.00 C 96.06 58.39 87.29 76.70 105.00 74.00 Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#7C3A2A",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 126.00 66.00  C 132.67 92.13 117.88 116.94 93.22 125.22 C 68.57 133.50 44.30 120.86 33.00 98.00 C 32.56 101.46 24.98 105.37 22.00 103.00 C 35.61 133.81 70.96 147.66 101.98 135.98 C 132.99 124.29 148.64 89.10 138.00 58.00 C 137.84 60.76 129.11 68.64 126.00 66.00 Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#803D2C",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 105.00 74.00  C 108.71 83.39 95.96 77.43 93.78 80.78 C 91.60 84.13 92.87 94.04 93.00 98.00 C 93.13 101.96 93.20 113.27 87.93 109.07 C 82.65 104.87 88.30 97.96 86.00 93.00 C 78.84 94.64 65.15 90.26 59.25 94.25 C 53.35 98.24 51.37 104.30 47.00 109.00 C 61.83 124.12 88.12 126.45 104.75 113.75 C 121.39 101.06 127.29 75.79 116.00 59.00 C 117.41 61.87 118.95 64.74 119.00 68.00 C 113.97 68.84 110.03 73.23 105.00 74.00 Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#8B4632",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 86.00 65.00  C 83.14 67.45 78.97 70.23 78.00 74.00 C 84.77 76.02 87.51 71.06 86.00 65.00 Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#884430",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 86.00 80.00  C 79.28 80.54 69.32 77.32 67.00 86.00 C 73.26 84.27 88.06 90.68 86.00 80.00 Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 0,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 0.00 160.00  L 160.00 160.00 L 160.00 0.00 L 0.00 0.00 L 0.00 160.00 M 90.00 8.00  C 142.76 14.38 168.26 81.61 136.25 122.25 C 104.23 162.89 38.12 160.54 14.69 110.31 C -8.73 60.07 32.38 1.04 90.00 8.00 Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#31100B",
    fillOpacity: 0.95,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 90.00 8.00  C 32.38 1.04 -8.73 60.07 14.69 110.31 C 38.12 160.54 104.23 162.89 136.25 122.25 C 168.26 81.61 142.76 14.38 90.00 8.00 M 116.00 29.00  C 125.93 36.10 134.10 46.60 138.00 58.00 C 148.64 89.10 132.99 124.29 101.98 135.98 C 70.96 147.66 35.61 133.81 22.00 103.00 C 10.86 77.79 18.89 47.85 40.25 30.25 C 61.61 12.64 93.94 13.24 116.00 29.00 Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#985239",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 22.00 103.00  C 24.98 105.37 32.56 101.46 33.00 98.00 C 11.66 54.85 67.98 13.84 105.00 37.00 C 110.24 38.33 113.07 34.51 118.00 33.00 C 118.55 31.18 116.25 30.53 116.00 29.00 C 93.94 13.24 61.61 12.64 40.25 30.25 C 18.89 47.85 10.86 77.79 22.00 103.00 Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#8B4732",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 105.00 37.00  C 115.33 43.46 123.03 54.39 126.00 66.00 C 129.11 68.64 137.84 60.76 138.00 58.00 C 134.10 46.60 125.93 36.10 116.00 29.00 C 116.25 30.53 118.55 31.18 118.00 33.00 C 113.07 34.51 110.24 38.33 105.00 37.00 Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#4F140A",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 33.00 98.00  C 44.30 120.86 68.57 133.50 93.22 125.22 C 117.88 116.94 132.67 92.13 126.00 66.00 C 123.03 54.39 115.33 43.46 105.00 37.00 C 67.98 13.84 11.66 54.85 33.00 98.00 M 116.00 59.00  C 127.29 75.79 121.39 101.06 104.75 113.75 C 88.12 126.45 61.83 124.12 47.00 109.00 C 51.37 104.30 53.35 98.24 59.25 94.25 C 65.15 90.26 78.84 94.64 86.00 93.00 C 88.30 97.96 82.65 104.87 87.93 109.07 C 93.20 113.27 93.13 101.96 93.00 98.00 C 92.87 94.04 91.60 84.13 93.78 80.78 C 95.96 77.43 108.71 83.39 105.00 74.00 C 87.29 76.70 96.06 58.39 94.00 47.00 C 75.15 61.51 61.21 87.37 41.00 101.00 C 30.08 80.84 36.53 52.42 57.23 41.23 C 77.93 30.04 105.28 37.89 116.00 59.00 M 86.00 65.00  C 87.51 71.06 84.77 76.02 78.00 74.00 C 78.97 70.23 83.14 67.45 86.00 65.00 M 86.00 80.00  C 88.06 90.68 73.26 84.27 67.00 86.00 C 69.32 77.32 79.28 80.54 86.00 80.00 Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "#914B35",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 105.00 74.00  C 110.03 73.23 113.97 68.84 119.00 68.00 C 118.95 64.74 117.41 61.87 116.00 59.00 C 105.28 37.89 77.93 30.04 57.23 41.23 C 36.53 52.42 30.08 80.84 41.00 101.00 C 61.21 87.37 75.15 61.51 94.00 47.00 C 96.06 58.39 87.29 76.70 105.00 74.00 Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "#7C3A2A",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 126.00 66.00  C 132.67 92.13 117.88 116.94 93.22 125.22 C 68.57 133.50 44.30 120.86 33.00 98.00 C 32.56 101.46 24.98 105.37 22.00 103.00 C 35.61 133.81 70.96 147.66 101.98 135.98 C 132.99 124.29 148.64 89.10 138.00 58.00 C 137.84 60.76 129.11 68.64 126.00 66.00 Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "#803D2C",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 105.00 74.00  C 108.71 83.39 95.96 77.43 93.78 80.78 C 91.60 84.13 92.87 94.04 93.00 98.00 C 93.13 101.96 93.20 113.27 87.93 109.07 C 82.65 104.87 88.30 97.96 86.00 93.00 C 78.84 94.64 65.15 90.26 59.25 94.25 C 53.35 98.24 51.37 104.30 47.00 109.00 C 61.83 124.12 88.12 126.45 104.75 113.75 C 121.39 101.06 127.29 75.79 116.00 59.00 C 117.41 61.87 118.95 64.74 119.00 68.00 C 113.97 68.84 110.03 73.23 105.00 74.00 Z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "#8B4632",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 86.00 65.00  C 83.14 67.45 78.97 70.23 78.00 74.00 C 84.77 76.02 87.51 71.06 86.00 65.00 Z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "#884430",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 86.00 80.00  C 79.28 80.54 69.32 77.32 67.00 86.00 C 73.26 84.27 88.06 90.68 86.00 80.00 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTariaBronze);
export default __webpack_public_path__ + "static/media/Taria_Bronze.55658aa3d671502e0a05a4183c40c7a4.svg";
export { ForwardRef as ReactComponent };